// This object must follow a structure.
// Discuss more.
// Write each app constants in `uppercase`, `snake_case`.

/**
 * `APP`.
 */
const APP = {
  ACCEPT_TERMS: 'AppAcceptTerms',
  ENABLE_NOTIFICATIONS: 'AppEnableNotifications',
  NOT_FOUND: 'AppNotFound',
  OPEN_PROZIS_STORE_APP: 'AppOpenProzisStoreApp',
  UNAUTHORIZED: 'AppUnauthorized',
  USE_PROZIS_STORE_APP: 'AppUseProzisStoreApp'
};

/**
 * `DASHBOARD`.
 */
const DASHBOARD = {
  DASHBOARD: 'DashboardView'
};

/**
 * `CHALLENGES`.
 */
const CHALLENGES = {
  CHALLENGES_DETAIL: 'ChallengesDetail',
  CHALLENGES_LIST: 'ChallengesList'
};

/**
 * `COUNTERPARTS`.
 */
const COUNTERPARTS = {
  COUNTERPART_DETAIL: 'CounterpartDetail',
  COUNTERPART_DETAIL_SUBMIT: 'CounterpartDetailSubmit',
  COUNTERPARTS_LIST: 'CounterpartsList'
};

/**
 * `EXTERNAL`.
 */
const EXTERNAL = {
  EXTERNAL_APPLICATIONS: 'ExternalApplications'
};

/**
 * `ORDERS`.
 */
const ORDERS = {
  FOLLOWER_MESSAGES: 'FollowerMessages',
  ORDERS: 'Orders',
  PRODUCTS: 'Products',
  PRODUCTS_OFFERED: 'ProductsOffered'
};

/**
 * `PARTNER`.
 */
const PARTNER = {
  COUNTERPARTS: 'CounterpartsList',
  DETAILS: 'PartnerDetails',
  REMUNERATIONS: 'RemunerationsModels'
};

/**
 * `PRODUCTS`.
 */
const PRODUCTS = {
  PRODUCTS: 'Products',
  PRODUCTS_OFFERED: 'ProductsOffered'
};

/**
 * `REMUNERATIONS`.
 */
const REMUNERATIONS = {
  CHALLENGE_REMUNERATIONS: 'ChallengeRemunerations',
  COMMISSION_REMUNERATIONS: 'CommissionRemunerations',
  COUPON_REMUNERATIONS: 'CouponRemunerations',
  FIXED_REMUNERATIONS: 'FixedRemunerations',
  INVOICE_REMUNERATIONS: 'InvoiceRemunerations',
  MANUAL_REMUNERATIONS: 'ManualRemunerations',
  REMUNERATIONS_MODELS: 'RemunerationsModels',
  REMUNERATIONS_POOL_PRODUCTS_REVIEW: 'RemunerationsPoolProductsReview',
  REMUNERATIONS_POOL_PRODUCTS_REVIEW_DETAILS:
    'RemunerationsPoolProductsReviewDetails'
};

/**
 * `CAMPAIGNS`.
 */
const CAMPAIGNS = {
  CAMPAIGNS_DETAIL: 'CampaignsDetail',
  CAMPAIGNS_LIST: 'CampaignsList',
  CAMPAIGNS_RESOLVE: 'CampaignsResolve',
  GENERICS_DETAIL: 'GenericsDetail',
  GENERICS_LIST: 'GenericsList'
};

/**
 * `MENTIONS`.
 */
const MENTIONS = {
  MENTIONS_LIST: 'MentionsList'
};

/**
 * `MEMBERS`.
 */
const MEMBERS = {
  PARTNER_MEMBERS: 'PartnerMembers'
};

/**
 * `COMMUNICATIONS`.
 */
const COMMUNICATIONS = {
  COMMUNICATIONS_DETAIL: 'CommunicationsDetail',
  COMMUNICATIONS_LIST: 'CommunicationsList'
};

/**
 * `CHAT`.
 */
const CHAT = {
  CHAT_DETAIL: 'ChatDetail'
};

/**
 * `LINKS`.
 */
const LINKS = {
  LINKS: 'Links'
};

/**
 * `SOCIAL_NETWORK`.
 */
const SOCIAL_NETWORK = {
  COMMENT_QUESTION_REPLY: 'SocialNetworkCommentQuestionReply',
  COMMENT_QUESTIONS: 'SocialNetworkCommentQuestions',
  POST_COMMENTS: 'SocialNetworkPostComments',
  POST_CREATE: 'SocialNetworkPostCreate',
  POST_DETAIL: 'SocialNetworkPostDetail',
  POST_PRODUCTS: 'SocialNetworkPostProducts',
  POST_UPDATE: 'SocialNetworkPostUpdate',
  PROFILE_BUSINESS_WALL: 'SocialNetworkProfileBussinessWall',
  PROFILE_CREATE: 'SocialNetworkProfileCreate',
  PROFILE_UPDATE: 'SocialNetworkProfileEdit',
  PROFILE_WAITING_APPROVAL: 'SocialNetworkProfileWaitingApproval',
  PROFILE_WALL: 'SocialNetworkProfileWall',
  STATISTICS_DASHBOARD: 'SocialNetworkStatisticsDashboard',
  STATISTICS_POST: 'SocialNetworkStatisticsPost',
  STATISTICS_PROFILE: 'SocialNetworkStatisticsProfile'
};

/**
 * `LIVE`.
 */
const LIVE = { HOME: 'LiveHome' };

/**
 * `CLUB`.
 */
const CLUB = { HOME: 'ClubHome' };

/**
 * `ON_DEMAND_CAMPAIGNS`.
 */
const ON_DEMAND_CAMPAIGNS = {
  DASHBOARD: 'CampaignsDashboard'
};

/**
 * `ROUTES`.
 */
export const ROUTES = {
  APP,
  CAMPAIGNS,
  CHALLENGES,
  CHAT,
  CLUB,
  COMMUNICATIONS,
  COUNTERPARTS,
  DASHBOARD,
  EXTERNAL,
  LINKS,
  LIVE,
  MEMBERS,
  MENTIONS,
  ON_DEMAND_CAMPAIGNS,
  ORDERS,
  PARTNER,
  PRODUCTS,
  REMUNERATIONS,
  SOCIAL_NETWORK
};
